module.exports = __webpack_public_path__ + "assets/img/icon8-menu.27e6f842.svg";